type WithKey<K extends string> = {[index in K]: unknown};

export function hasOwnProperty<K extends string>(o: {}, k: K): o is WithKey<K> {
	return Object.prototype.hasOwnProperty.call(o, k);
}
